const FORBIDDEN =
  /\b(insert|update|delete|drop|create|alter|attach|copy|export|import|pragma|call|execute|grant|revoke|truncate|replace)\b/i;

export class SqlGuardError extends Error {
  constructor(message: string) {
    super(message);
    this.name = "SqlGuardError";
  }
}

export function validateReadOnlySql(sql: string): string {
  const trimmed = sql.trim();
  if (!trimmed) {
    throw new SqlGuardError("SQL must not be empty");
  }
  if (trimmed.includes(";")) {
    throw new SqlGuardError("Multiple statements are not allowed");
  }
  if (!/^\s*select\b/i.test(trimmed)) {
    throw new SqlGuardError("Only SELECT queries are allowed");
  }
  if (FORBIDDEN.test(trimmed)) {
    throw new SqlGuardError("Query contains forbidden keywords");
  }
  return trimmed;
}
